import { useLocalObservable } from 'mobx-react-lite';
import React, { createContext } from 'react';

import { useLogsMode } from '@/features/logsMode';
import { useStrictContext } from '@/hooks/useStrictContext';

import { FavoriteUsersModel } from './FavoriteUsersModel';

interface ProviderProps {
  children: React.ReactNode;
}

const FavoriteUsersContext = createContext<FavoriteUsersModel | null>(null);

export const FavoriteUsersProvider: React.FC<ProviderProps> = ({ children }) => {
  const mode = useLogsMode();
  const favoriteUsersModel = useLocalObservable(() => new FavoriteUsersModel(mode));

  return (
    <FavoriteUsersContext.Provider value={favoriteUsersModel}>
      {children}
    </FavoriteUsersContext.Provider>
  );
};

export function useFavoriteUsers() {
  const store = useStrictContext({
    context: FavoriteUsersContext,
    message: 'useFavoriteUsers must be used within FavoriteUsersProvider',
  });

  return store;
}
